"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Skeleton = _interopRequireDefault(require("../../Skeleton"));

var _Text = _interopRequireDefault(require("../../Text"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _useIsLoading = _interopRequireDefault(require("../LoadingProvider/useIsLoading"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Advertisement = function Advertisement(props) {
  var _props$advertisement = props.advertisement,
      advertisement = _props$advertisement === void 0 ? '' : _props$advertisement,
      other = (0, _objectWithoutProperties2["default"])(props, ["advertisement"]);
  var isLoading = (0, _useIsLoading["default"])();
  var Content = (0, _react.useCallback)(function () {
    if (isLoading) {
      return (0, _core.jsx)(_react["default"].Fragment, null, (0, _core.jsx)(_Text["default"], {
        as: "span",
        gutter: 2
      }, (0, _core.jsx)(_Skeleton["default"], {
        width: "85%"
      })), (0, _core.jsx)(_Text["default"], {
        as: "span"
      }, (0, _core.jsx)(_Skeleton["default"], {
        width: "40%"
      })));
    }

    return (0, _core.jsx)(_Text["default"], {
      as: "span",
      variant: "paragraph"
    }, advertisement);
  }, [advertisement, isLoading]);

  if (!advertisement && !isLoading) {
    return null;
  }

  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    flexDirection: "column"
  }, other), (0, _core.jsx)(Content, null));
};

__signature__(Advertisement, "useIsLoading{isLoading}\nuseCallback{Content}", function () {
  return [_useIsLoading["default"]];
});

var _default = Advertisement;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Advertisement, "Advertisement", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/Advertisement.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/Advertisement.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();